import ip from 'icepick';
import {
  INSURANCE_EXPIRY_DATE,
  SET_PROPOSAL_DETAILS,
  UPDATE_ADDONS,
  UPDATE_IDV,
  UPDATE_NCB,
  UPDATE_VEHICLE_FILTER_DATA,
  RESET_INSURANCE,
  UPDATING_QUOTE,
} from './type';

const initialState = ip.freeze({
  idv: {
    currentIdv: null,
    previousIdv: null,
  },
  policyExpiryDate: {
    odPolicyExpiryDate: null,
    tpPolicyExpiryDate: null,
  },
  ncb: {
    ncbApplicable: true,
    ncbDiscount: null,
  },
  proposalData: null,
  selectedAddons: [],
  vehicleFilterData: null,
  isQuoteUpdating: false,
});

const carInsuranceReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case RESET_INSURANCE: {
      state = ip.assign(state, {
        idv: {
          currentIdv: null,
          previousIdv: null,
        },
        policyExpiryDate: {
          odPolicyExpiryDate: null,
          tpPolicyExpiryDate: null,
        },
        ncb: {
          ncbApplicable: true,
          ncbDiscount: null,
        },
        proposalData: null,
        selectedAddons: [],
        vehicleFilterData: null,
      });
      return state;
    }
    case INSURANCE_EXPIRY_DATE: {
      state = ip.setIn(state, ['policyExpiryDate'], payload);
      return state;
    }
    case UPDATE_VEHICLE_FILTER_DATA: {
      state = ip.setIn(state, ['vehicleFilterData'], payload);
      return state;
    }
    case UPDATE_IDV: {
      state = ip.setIn(state, ['idv'], payload);
      return state;
    }
    case UPDATE_NCB: {
      state = ip.setIn(state, ['ncb'], payload);
      return state;
    }
    case UPDATE_ADDONS: {
      state = ip.setIn(state, ['selectedAddons'], payload);
      return state;
    }
    case UPDATING_QUOTE: {
      state = ip.setIn(state, ['isQuoteUpdating'], payload);
      return state;
    }
    case SET_PROPOSAL_DETAILS: {
      state = ip.setIn(state, ['proposalData'], payload);
      return state;
    }

    default: {
      return state;
    }
  }
};

export default carInsuranceReducer;
